import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "./index";

/**
 * Drop this into any component rendered INSIDE the Router (App.js already
 * does this) to get automatic, de-duplicated SPA pageview tracking on
 * every react-router-dom navigation.
 */
export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search]);
}
